import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import {
  SHIFT_COMMENTS_LOAD_ALL,
  SHIFT_COMMENTS_RESET_PAGE,
  SHIFT_COMMENTS_GRID_SORT,
  SHIFT_COMMENTS_GRID_CURRENT_PAGE,
  SHIFT_COMMENTS_GRID_SEARCH_TEXT
} from '../actionTypes';
import { hide as hideBusyIndicator, show as showBusyIndicator } from './busyIndicatorActions';
import { showAlert, clearAllAlerts } from './alertActions';
import PreCheckQuestionsService from '../../services/PredefinedShiftCommentService';
import { formatErrorMessage } from '../../utils/common';

export const refreshData = (): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
  dispatch(showBusyIndicator());
  dispatch(clearAllAlerts());
  PreCheckQuestionsService.getAllComments()
    .then((result) => {
      dispatch({
        type: SHIFT_COMMENTS_LOAD_ALL,
        data: result
      });
    }).catch((err) => {
      dispatch(showAlert(formatErrorMessage(JSON.parse(err.response))));
    }).then(() => {
      dispatch(hideBusyIndicator());
    });
};

export const reset = () => ({
  type: SHIFT_COMMENTS_RESET_PAGE
});

export const searchByText = (text: string) => ({
  type: SHIFT_COMMENTS_GRID_SEARCH_TEXT,
  data: text
});

export const changePage = (page = 1) => ({
  type: SHIFT_COMMENTS_GRID_CURRENT_PAGE,
  data: page
});

export const changeSortModel = (sortModel = []) => ({
  type: SHIFT_COMMENTS_GRID_SORT,
  data: sortModel
});
